<svg [attr.viewBox]="viewBox" [style.width]="computedWidth" [style.height]="computedHeight"
     [attr.width]="computedWidth" [attr.height]="computedHeight"
     class="img-fluid" [class.mx-auto]="center" [attr.aria-labelledby]="ariaLabelledBy && ('#' + ariaLabelledBy) || null"
     aria-hidden="true" focusable="false">
    <title *ngIf="ariaTitle " [attr.id]="ariaLabelledBy">
        {{ ariaTitle }}
    </title>
    <use [attr.xlink:href]="'/content/images/symbol-defs.svg#' + type" />
</svg>
